import { FailBannerIcon, PendingBannerIcon, SuccessBannerIcon } from "@Icons/MainIcons";
import { ReactNode } from "react";
import { OrderStatus } from "src/Modules/UserHistory/constants/OrdersList";

type BookingHeroStatus = {
  icon: ReactNode;
  title: string;
  text: string;
  subtitle?: string;
  /** Trans key, receives `email` and an `<email>` component */
  description?: string;
  /** used instead of `description` when no email is available */
  descriptionNoEmail?: string;
  showReference?: boolean;
  showBackToSearch?: boolean;
  color: {
    text: string;
    background: string;
    gradient: string;
  };
};

const SUCCESS_STATUS: BookingHeroStatus = {
  icon: <SuccessBannerIcon className="w-5! h-5!" />,
  title: "BookingResult.success.title",
  text: "BookingResult.success.text",
  subtitle: "BookingResult.success.subtitle",
  description: "BookingResult.success.description",
  descriptionNoEmail: "BookingResult.success.descriptionNoEmail",
  showReference: true,
  color: { text: "text-font-success", background: "bg-background-success", gradient: "from-background-success" },
};

export const STATUS_MAP: Record<OrderStatus, BookingHeroStatus> = {
  [OrderStatus.Success]: SUCCESS_STATUS,
  [OrderStatus.Failed]: {
    icon: <FailBannerIcon className="w-5! h-5!" />,
    title: "BookingResult.failed.title",
    text: "BookingResult.failed.text",
    subtitle: "BookingResult.failed.subtitle",
    description: "BookingResult.failed.description",
    showBackToSearch: true,
    color: { text: "text-font-danger", background: "bg-background-danger", gradient: "from-background-danger" },
  },
  [OrderStatus.Pending]: {
    icon: <PendingBannerIcon className="w-5! h-5!" />,
    title: "BookingResult.pending.title",
    text: "BookingResult.pending.text",
    subtitle: "BookingResult.pending.subtitle",
    description: "BookingResult.pending.description",
    descriptionNoEmail: "BookingResult.pending.descriptionNoEmail",
    color: { text: "text-font-warning", background: "bg-background-warning", gradient: "from-background-warning" },
  },
  [OrderStatus.Canceled]: {
    icon: <FailBannerIcon className="w-5! h-5!" />,
    title: "BookingResult.canceled.title",
    text: "BookingResult.canceled.text",
    description: "BookingResult.canceled.description",
    showBackToSearch: true,
    color: { text: "text-font-danger", background: "bg-background-danger", gradient: "from-background-danger" },
  },
  [OrderStatus.Booked]: SUCCESS_STATUS,
  [OrderStatus.Ticketed]: SUCCESS_STATUS,
  [OrderStatus.Confirmed]: SUCCESS_STATUS,
};
